// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setMasterData } from "_core/slices/datas/MasterSlice";
import { setApiTimestamp, setTransactionData, deleteTransactionData, mergeTransactionData } from "_core/slices/datas/TransactionSlice";


const AdminExecEvaluationApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/exec_evaluation";

    // API実行
    const ExecAdminExecEvaluationApi = async () => {

        // 必要なリクエストを定義
        const requestParams = {};
    
        let response = null;
        let error = null;
    
        // console.log(url + "API開始");
        try {
            response = await ApiRequest({  url:url, requestParams:requestParams});
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));

            dispatch(setTransactionData({
                tUser: response['t_user'],
            }));
            
        }
        return { response, error };
    };

    return ExecAdminExecEvaluationApi;
};

export default AdminExecEvaluationApi;